import { Loading } from 'src/components'
import { Wrapper } from './fullScreenLoader.styles'
import { FullScreenLoaderProps } from './fullScreenLoader.types'

const FullScreenLoader = ({ hasMainHeader }: FullScreenLoaderProps) => {
  return (
    <Wrapper hasMainHeader={Boolean(hasMainHeader)} data-test="full-screen-loader">
      <Loading full />
    </Wrapper>
  )
}

export default FullScreenLoader
